import YetiClient from "./YetiClient";

const YetiCustomer = {
    /**
     * Retrieves customer data from the Yeti API.
     * @returns {Promise} A promise that resolves to the customer data.
     */
    getCustomerData: async function () {
        return YetiClient.get(`/customers/customer`);
    },
};

export default YetiCustomer;
